import { render } from "./HeaderList.vue?vue&type=template&id=1ece2aa6"
import script from "./HeaderList.vue?vue&type=script&lang=js"
export * from "./HeaderList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSK\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__